import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { NodGateEnteryRoute } from "./gate-entry.routes";

export function GateEntery() {
  return (
    <Layout>
      {NodGateEnteryRoute.subRoutes && (
        <ModuleRouter subRoutes={NodGateEnteryRoute.subRoutes} path={NodGateEnteryRoute.path} />
      )}
    </Layout>
  );
}
